import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/store';
import CircularProgress from '@mui/material/CircularProgress';
import LoadingCenter from './util/LoadingCenter';
import { useLocation } from "react-router-dom";
import AddEquipment from './modal/AddEquipment';
import SidePanel from './util/SidePanel';
import SettingsPanelBody from './util/SettingsPanelBody';
import { t } from 'i18next';
import EditEquipment from './modal/EditEquipment';
import { useSnackbar } from 'notistack';
import ApproveDownload from './modal/ApproveDownload';
import DownloadIcon from '@mui/icons-material/Download';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faXmark } from '@fortawesome/free-solid-svg-icons';
import PublishIcon from '@mui/icons-material/Publish';
import ShowNewLocation from './modal/ShowNewLocation';
import ShowToDo from './modal/ShowToDo';
import ShowNon from './modal/ShowNon';
import FileSaver from 'file-saver';
import AddIcon from '@mui/icons-material/Add';
import EquipmentSettings from './modal/EquipmentSettings';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import moment from 'moment';
import TabPanel from '@mui/lab/TabPanel';
import TabMenu from './util/TabMenu';
import PageToolbar from './util/PageToolbar';
import DataTable, { ColDef } from './util/DataTable';
import SearchFilter, { applyColumnFilters, applySearchAndFilters, ActiveFilter } from './util/SearchFilter';
import EquipExpandPanel from './equipmentComponents/EquipExpandPanel';
import ActivityLogPanel from './util/ActivityLogPanel';
import { addMonths, format } from 'date-fns';

const CAT_COLORS = ['#0891b2','#7c3aed','#d97706','#059669','#dc2626','#2563eb','#9333ea','#0d9488'];

const ModeBtn = ({ active, onClick, activeStyle, children }: {
  active: boolean; onClick: () => void; activeStyle: React.CSSProperties; children: React.ReactNode;
}) => (
  <button type="button" onClick={onClick} style={{
    display: 'inline-flex', alignItems: 'center', gap: 5,
    padding: '5px 11px', borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: 'pointer',
    border: '1px solid var(--border-input)', transition: 'all .15s', whiteSpace: 'nowrap',
    ...(active ? activeStyle : { background: 'var(--btn-user-form)', color: 'var(--text-color)' }),
  }}>{children}</button>
);


const StatusCell = ({ equip, access, statusList, onRefresh }: {
  equip: any; access: any; statusList: any[]; onRefresh: () => void;
}) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleSelect = async (statusId: number) => {
    try {
      await axios.put(`equipment/${equip.id}`, { statusId: statusId === -1 ? null : statusId });
      onRefresh();
    } finally {
      setAnchor(null);
    }
  };

  return (
    <>
      <span
        className={access.equipment_inventory_mode ? 'cursor-pointer' : ''}
        onClick={access.equipment_inventory_mode ? (e: any) => setAnchor(e.currentTarget) : undefined}
      >
        {equip.statusId ? equip.status?.name ?? '' : ''}
      </span>
      {access.equipment_inventory_mode && (
        <Menu
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={() => setAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <MenuItem onClick={() => handleSelect(-1)}>none</MenuItem>
          {statusList.map((s: any) => (
            <MenuItem key={s.id} onClick={() => handleSelect(s.id)}>{s.name}</MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

interface EquipmentProps {
  access: any
}

const Equipment: React.FC<EquipmentProps> = ({ access }) => {
  const auth = useSelector((state: RootState) => state.auth.value);
  const [status, setStatus] = useState<any[]>([]);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [selectedUser, setSelectedUser] = useState<null>(null);
  const [show, setShow] = useState(false);
  const [locationRow, setLocationRow] = useState<any>();
  const [categoryRow, setCategoryRow] = useState<any>();
  const [dublicateRow, setDublicateRow] = useState<any>();
  const [dublicateWhisRow, setDublicateWhisRow] = useState<any>();
  const [errorNameRow, setErrorNameRow] = useState<any>();
  const [statusRow, setStatusRow] = useState<any>();
  const [errorRow, setErrorRow] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<any>();
  const [openShow, setOpenShow] = useState(false);
  const [openDo, setOpenDo] = useState(false);
  const [openNon, setOpenNon] = useState(false);
  const [equip, setEquip] = useState<any[]>([]);
  const [locations, setLocations] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [userID, setUserID] = useState<any>();
  const location = useLocation();
  const [value, setValue] = useState('inventory');
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [showAprove, setShowAprove] = useState(false);
  const [showAproveEquipment, setShowAproveEquipment] = useState(false);
  const [showEditSetting, setShowEditSetting] = useState(false);
  const [invMode,  setInvMode]  = useState(false);
  const [patMode,  setPatMode]  = useState(false);
  const [bookMode, setBookMode] = useState(false);
  const [duplicatePrefill, setDuplicatePrefill] = useState<any>(null);
  const [equipSearch, setEquipSearch] = useState('');
  const [equipFilters, setEquipFilters] = useState<ActiveFilter[]>([]);
  const [historyEntityId, setHistoryEntityId] = useState<number | null>(null);
  const [archiveItems, setArchiveItems] = useState<any[]>([]);
  const [archiveSearch, setArchiveSearch] = useState('');
  const [archiveFilters, setArchiveFilters] = useState<ActiveFilter[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const toolbarSlot  = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleChangeAll = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleShowAdd = () => setShowModalAdd(true);

  const handleShow = (equip: any) => {
    setSelectedUser(equip);
    setShow(true);
  };

  const refreshEquip = useCallback(async () => {
    try {
      const { data: usersEquip } = await axios.get('equipment');
      if (usersEquip) {
        setEquip(usersEquip.sort((a: any, b: any) => a.inventory_id - b.inventory_id));
      }
    } catch (error: any) {
      console.log('error equipment');
    }
  }, []);

  const refreshArchive = useCallback(async () => {
    try {
      const { data } = await axios.get('equipment/archive');
      setArchiveItems(data ?? []);
    } catch {}
  }, []);

  const handleMoveToArchive = useCallback(async (id: number) => {
    try {
      await axios.delete(`equipment/${id}`);
      enqueueSnackbar(t('MovedToArchive') || 'Moved to archive', { variant: 'success' });
      refreshEquip();
    } catch {
      enqueueSnackbar('Error', { variant: 'error' });
    }
  }, [refreshEquip, enqueueSnackbar]);

  const handleRestoreFromArchive = useCallback(async (id: number) => {
    try {
      await axios.post(`equipment/archive/${id}/restore`);
      enqueueSnackbar(t('Restored') || 'Restored', { variant: 'success' });
      await Promise.all([refreshEquip(), refreshArchive()]);
    } catch {
      enqueueSnackbar('Error', { variant: 'error' });
    }
  }, [refreshEquip, refreshArchive, enqueueSnackbar]);

  useEffect(() => {
    setLoading(true);
    const checkAuth = async () => {
      try {
        const { data } = await axios.get('user');
        const { data: usersEquip } = await axios.get('equipment');
        const { data: statusData } = await axios.get('status');
        const { data: locationData } = await axios.get('location');
        const { data: usersData } = await axios.get('users');
        if (data) {
          setUserID(data.id);
        }
        if (usersEquip) {
          setEquip(usersEquip.sort((a: any, b: any) => a.inventory_id - b.inventory_id));
        }
        if (statusData) {
          setStatus(statusData.filter((stat: any) => stat.active));
        }
        if (locationData) {
          setLocations(locationData);
        }
        if (usersData) {
          setUsers(usersData);
        }
      } catch (e) {
        // auth errors are handled by the global interceptor
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (value === 'archive') refreshArchive();
  }, [value, refreshArchive]);

  const handleEquipmentXls = async () => {
    try {
      const payload = { equipmentId: equip.map((e: any) => e.id) };
      const response = await axios.post('equipment/export/xlsx', payload, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, 'equipment.xlsx');
      enqueueSnackbar('File successfully saved', { variant: 'success' });
      setShowAproveEquipment(false);
    } catch (error) {
      enqueueSnackbar(`Error exporting equipment`, { variant: 'error' });
    }
  };

  const importCSV = async (id: any, item: any) => {
    if (file) {
      try {
        const formData = new FormData();
        formData.append('equipment', file);
        await axios.post(`equipment/upload/?saveConfig_id=${id}&saveConfig_error=${item}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        enqueueSnackbar(`${file.name} uploading success`, { variant: 'success' });
        refreshEquip();
        setFile(null);
      } catch (error: any) {
        if (error.response?.status === 404) {
          setLocationRow(error.response?.data.newLocation);
          setCategoryRow(error.response?.data.newCategoryEquipment);
          setStatusRow(error.response?.data.newStatus);
          setOpenShow(true);
        } else if (error.response?.status === 403) {
          setDublicateRow(error.response?.data.idDublicate);
          setErrorMessage(error.response?.data.message);
          setErrorNameRow(error.response?.data.errorName);
          setDublicateWhisRow(error.response?.data.dublicate);
          setOpenNon(true);
        } else if (error.response?.status === 401) {
          enqueueSnackbar('You do not have permission', { variant: 'error' });
        } else if (error.response?.status === 400) {
          enqueueSnackbar('Error uploading file', { variant: 'error' });
          setErrorRow(error.response?.data.error);
          setOpenDo(true);
        } else {
          enqueueSnackbar('Error', { variant: 'error' });
        }
      }
    }
  };

  const downloadSampleXLS = useCallback(async () => {
    try {
      const response = await axios.post('equipment/csv', null, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'sample_equipment.xlsx');
      document.body.appendChild(link);
      link.click();
      setShowAprove(false);
    } catch (error) {
      enqueueSnackbar('Error downloading sample xlsx', { variant: 'error' });
    }
  }, [enqueueSnackbar]);

  const handleRefreshInventory = useCallback(async (equpId: number) => {
    try {
      await axios.put(`equipment/${equpId}`, { inventory_date: new Date(), inventoryUserId: userID });
      const { data: updated } = await axios.get(`equipment/${equpId}`);
      setEquip(prev => prev.map(e => e.id === equpId ? updated : e));
    } catch (error) {
      console.error('Error updating inventory date:', error);
    }
  }, [userID]);

  const handleRefreshPat = useCallback(async (equpId: number) => {
    try {
      await axios.put(`equipment/${equpId}`, { pat_date: new Date(), patUserId: userID });
      const { data: updated } = await axios.get(`equipment/${equpId}`);
      setEquip(prev => prev.map(e => e.id === equpId ? updated : e));
    } catch (error) {
      console.error('Error updating PAT date:', error);
    }
  }, [userID]);

  const handleDeleteMany = useCallback(async (ids: (string | number)[]) => {
    await Promise.all(ids.map((id) => axios.delete(`equipment/${id}`)));
    enqueueSnackbar(t('MovedToArchive') || 'Moved to archive', { variant: 'success' });
    await refreshEquip();
  }, [refreshEquip, enqueueSnackbar]);

  const categoryOptions = useMemo(() => {
    const seen = new Map<any, any>();
    equip.map((e: any) => e.categoryEquipment).filter(Boolean).forEach((c: any) => seen.set(c.id, c));
    return Array.from(seen.values()).map((c: any) => ({ value: String(c.id), label: c.name }));
  }, [equip]);

  const locationOptions = useMemo(() =>
    locations.map((l: any) => ({ value: String(l.id), label: l.name })),
  [locations]);

  const statusOptions = useMemo(() =>
    status.map((s: any) => ({ value: String(s.id), label: s.name })),
  [status]);

  const userOptions = useMemo(() => {
    const seen = new Map<number, any>();
    equip.forEach((e: any) => {
      if (e.responsibleUser?.id) seen.set(e.responsibleUser.id, e.responsibleUser);
    });
    return Array.from(seen.values()).map((u: any) => ({ value: String(u.id), label: `${u.first_name} ${u.last_name}` }));
  }, [equip]);

  const bulkEditFields = useMemo(() => {
    if (!access.equipment_edit) return undefined;
    return [
      {
        key: 'statusId',
        label: t('Status'),
        type: 'select' as const,
        options: [{ value: '', label: '— none —' }, ...statusOptions],
      },
      {
        key: 'locationId',
        label: t('Location'),
        type: 'select' as const,
        options: [{ value: '', label: '— none —' }, ...locationOptions],
      },
      {
        key: 'categoryEquipmentId',
        label: t('Category'),
        type: 'select' as const,
        options: [{ value: '', label: '— none —' }, ...categoryOptions],
      },
      {
        key: 'responsibleUserId',
        label: t('Responsive'),
        type: 'select' as const,
        options: [{ value: '', label: '— none —' }, ...userOptions],
      },
      {
        key: 'pat_test',
        label: t('PAT test'),
        type: 'select' as const,
        options: [
          { value: '', label: '— none —' },
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
      },
      {
        key: 'rental_opportunity',
        label: t('RentalOpportunity'),
        type: 'select' as const,
        options: [
          { value: '', label: '— none —' },
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
      },
      {
        key: 'capitalised',
        label: t('Capitalised'),
        type: 'select' as const,
        options: [
          { value: '', label: '— none —' },
          { value: 'true', label: 'Yes' },
          { value: 'false', label: 'No' },
        ],
      },
    ];
  }, [access.equipment_edit, statusOptions, locationOptions, categoryOptions, userOptions]);

  const handleDuplicate = useCallback((eq: any) => {
    setDuplicatePrefill({
      item_name: eq.item_name, manufacturer: eq.manufacturer, model: eq.model,
      categoryEquipmentId: eq.categoryEquipmentId, locationId: eq.locationId,
      responsibleUserId: eq.responsibleUserId, statusId: eq.statusId,
      cost: eq.cost, purchase_date: eq.purchase_date, warranty: eq.warranty,
      pat_test: eq.pat_test, pat_due: eq.pat_due,
      rental_opportunity: eq.rental_opportunity, capitalised: eq.capitalised,
      depreciation_method: eq.depreciation_method, depreciation_months: eq.depreciation_months,
      funding_strand: eq.funding_strand, notes: eq.notes,
    });
    setShowModalAdd(true);
  }, []);

  const handleBulkEdit = useCallback(async (ids: (string | number)[], field: string, value: any) => {
    let parsed: any;
    if (value === '') parsed = null;
    else if (value === 'true') parsed = true;
    else if (value === 'false') parsed = false;
    else if (value !== '' && !isNaN(Number(value))) parsed = Number(value);
    else parsed = value;
    await Promise.all(ids.map((id) => axios.put(`equipment/${id}`, { [field]: parsed })));
    enqueueSnackbar('Updated', { variant: 'success' });
    await refreshEquip();
  }, [refreshEquip, enqueueSnackbar]);

  const filteredEquip = useMemo(() => {
    let rows = equip;
    if (patMode)  rows = rows.filter((e: any) => e.pat_test === true);
    if (bookMode) rows = rows.filter((e: any) => e.rental_opportunity === true);
    if (!equipSearch) return rows;
    const q = equipSearch.toLowerCase();
    return rows.filter((e: any) =>
      (e.item_name && e.item_name.toLowerCase().includes(q)) ||
      (e.inventory_id && String(e.inventory_id).toLowerCase().includes(q)) ||
      (e.manufacturer && e.manufacturer.toLowerCase().includes(q)) ||
      (e.model && e.model.toLowerCase().includes(q)) ||
      (e.categoryEquipment?.name && e.categoryEquipment.name.toLowerCase().includes(q)) ||
      (e.location?.name && e.location.name.toLowerCase().includes(q)) ||
      (e.responsibleUser?.first_name && e.responsibleUser.first_name.toLowerCase().includes(q)) ||
      (e.responsibleUser?.last_name && e.responsibleUser.last_name.toLowerCase().includes(q))
    );
  }, [equip, equipSearch, patMode, bookMode]);

  const commonColumns = useMemo((): ColDef<any>[] => [
    {
      key: 'inventory_id',
      label: t('ID'),
      width: '5%',
      sortExtract: (r) => parseInt(r.inventory_id) || 0,
      render: (r) => r.inventory_id,
    },
    {
      key: 'item_name',
      label: t('Item'),
      filterType: 'text',
      render: (r) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{
            display: 'inline-block', width: 3, height: 30, borderRadius: 2, flexShrink: 0, marginRight: 10,
            background: r.categoryEquipment?.color ?? CAT_COLORS[(r.categoryEquipmentId ?? 0) % CAT_COLORS.length],
          }} />
          <div>
            <div style={{ fontWeight: 600, color: 'var(--text-color)', fontSize: 13 }}>{r.item_name}</div>
            {r.manufacturer && <div style={{ fontSize: 10, color: 'var(--text-color-calendar-week)', marginTop: 1 }}>{r.manufacturer}</div>}
          </div>
        </div>
      ),
    },
    {
      key: 'manufacturer',
      label: t('Manufacturer'),
      filterType: 'text',
      render: (r) => r.manufacturer ?? '',
    },
    {
      key: 'model',
      label: t('Model'),
      filterType: 'text',
      render: (r) => r.model ?? '',
    },
    {
      key: 'category',
      label: t('Category'),
      filterType: 'select',
      filterExtract: (r) => String(r.categoryEquipment?.id ?? ''),
      filterOptions: categoryOptions,
      sortExtract: (r) => r.categoryEquipment?.name?.toLowerCase() ?? '',
      render: (r) => r.categoryEquipment?.name ?? '',
    },
    {
      key: 'location',
      label: t('Location'),
      filterType: 'select',
      filterExtract: (r) => String(r.locationId ?? ''),
      filterOptions: locationOptions,
      sortExtract: (r) => r.location?.name?.toLowerCase() ?? '',
      render: (r) => r.location?.name ?? '',
    },
    {
      key: 'responsibleUser',
      label: t('Responsive'),
      filterType: 'select',
      filterExtract: (r) => String(r.responsibleUserId ?? ''),
      filterOptions: userOptions,
      sortExtract: (r) => `${r.responsibleUser?.first_name ?? ''} ${r.responsibleUser?.last_name ?? ''}`.toLowerCase(),
      render: (r) => r.responsibleUser ? `${r.responsibleUser.first_name} ${r.responsibleUser.last_name}` : '',
    },
    {
      key: 'pat_test',
      label: t('PAT test'),
      filterType: 'boolean',
      filterExtract: (r) => String(r.pat_test),
      filterOptions: [{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }],
      sortExtract: (r) => {
        if (!r.pat_test || !r.pat_date) return 0;
        return addMonths(new Date(r.pat_date), r.pat_due || 0).getTime();
      },
      render: (r) => {
        const due = r.pat_test && r.pat_date && r.pat_due ? addMonths(new Date(r.pat_date), r.pat_due) : null;
        const overdue = due && due < new Date();
        return (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {patMode && r.pat_test && (
              <button type="button" className="eq-quick-btn pat"
                onClick={e => { e.stopPropagation(); handleRefreshPat(r.id); }}
                title="Update PAT date to today">⟳</button>
            )}
            {!r.pat_test
              ? <span style={{ color: 'var(--text-color-calendar-week)', fontSize: 11 }}>—</span>
              : overdue
                ? <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 8, background: 'rgba(220,38,38,.1)', color: '#dc2626' }}>⚠ Overdue</span>
                : due
                  ? <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 8, background: 'rgba(5,150,105,.1)', color: '#059669' }}>✓ {format(due, 'MMM yyyy')}</span>
                  : <span style={{ fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 8, background: 'rgba(5,150,105,.1)', color: '#059669' }}>✓</span>
            }
          </div>
        );
      },
    },
    {
      key: 'purchase_date',
      label: t('PurchaseDate'),
      sortExtract: (r) => r.purchase_date ? new Date(r.purchase_date).getTime() : 0,
      render: (r) => r.purchase_date ? moment(r.purchase_date).format('DD.MM.YYYY') : '',
    },
    {
      key: 'serial_number',
      label: t('SerialNumber'),
      defaultVisible: false,
      filterType: 'text' as const,
      filterExtract: (r) => r.serial_number ?? '',
      render: (r) => r.serial_number ?? '',
    },
    {
      key: 'rental_opportunity',
      label: t('RentalOpportunity'),
      defaultVisible: false,
      filterType: 'boolean' as const,
      filterExtract: (r) => String(r.rental_opportunity ?? false),
      filterOptions: [{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }],
      sortExtract: (r) => r.rental_opportunity ? 1 : 0,
      render: (r) => r.rental_opportunity ? 'Yes' : 'No',
    },
  ], [categoryOptions, locationOptions, userOptions]);

  const inventoryColumns = useMemo((): ColDef<any>[] => [
    ...commonColumns,
    {
      key: 'inventory_date',
      label: t('InventoryDate'),
      sortExtract: (r) => r.inventory_date ? new Date(r.inventory_date).getTime() : 0,
      render: (r) => r.inventory_date ? moment(r.inventory_date).format('DD.MM.YYYY') : '',
    },
    {
      key: 'inventoryUser',
      label: t('InventoryUser'),
      sortExtract: (r) => `${r.inventoryUser?.first_name ?? ''} ${r.inventoryUser?.last_name ?? ''}`.toLowerCase(),
      render: (r) => r.inventoryUser ? `${r.inventoryUser.first_name} ${r.inventoryUser.last_name}` : '',
    },
    {
      key: 'cost',
      label: t('Cost'),
      sortExtract: (r) => parseFloat(r.cost) || 0,
      render: (r) => r.cost ?? '',
    },
    {
      key: 'warranty',
      label: t('WarrantyDue'),
      defaultVisible: false,
      sortExtract: (r) => r.warranty ? new Date(r.warranty).getTime() : 0,
      render: (r) => r.warranty ? moment(r.warranty).format('DD.MM.YYYY') : '',
    },
    {
      key: 'capitalised',
      label: t('Capitalised'),
      defaultVisible: false,
      filterType: 'boolean' as const,
      filterExtract: (r) => String(r.capitalised ?? false),
      filterOptions: [{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }],
      sortExtract: (r) => r.capitalised ? 1 : 0,
      render: (r) => r.capitalised ? 'Yes' : 'No',
    },
    {
      key: 'notes',
      label: t('Notes'),
      defaultVisible: false,
      filterType: 'text' as const,
      render: (r) => r.notes ?? '',
    },
    {
      key: 'status',
      label: t('Status'),
      filterType: 'select',
      filterExtract: (r) => String(r.statusId ?? ''),
      filterOptions: statusOptions,
      sortExtract: (r) => r.status?.name?.toLowerCase() ?? '',
      render: (r) => r.statusId ? (
        <span className="sbadge" style={{
          background: r.status?.color ? `${r.status.color}22` : 'rgba(5,150,105,.12)',
          color: r.status?.color ?? '#059669',
        }}>
          {r.status.name}
        </span>
      ) : <StatusCell equip={r} access={access} statusList={status} onRefresh={refreshEquip} />,
    },
  ], [commonColumns, invMode, patMode, statusOptions, status, access, handleRefreshInventory, handleRefreshPat, refreshEquip]);

  // Поиск (filteredEquip) + колоночные фильтры из SearchFilter
  const shownEquip = useMemo(
    () => applyColumnFilters(filteredEquip, equipFilters, inventoryColumns),
    [filteredEquip, equipFilters, inventoryColumns],
  );

  const archiveColumns = useMemo((): ColDef<any>[] => [
    ...commonColumns,
    {
      key: 'deletedAt',
      label: t('ArchivedAt') || 'Archived',
      sortExtract: (r: any) => r.deletedAt ? new Date(r.deletedAt).getTime() : 0,
      render: (r: any) => r.deletedAt
        ? moment(r.deletedAt).format('DD.MM.YYYY HH:mm')
        : '',
    },
    {
      key: 'restore',
      label: '',
      render: (r: any) => (
        <button
          type="button"
          className="btn-primary"
          style={{ fontSize: 11, padding: '3px 10px' }}
          onClick={() => handleRestoreFromArchive(r.id)}
        >
          {t('Restore') || 'Restore'}
        </button>
      ),
    },
  ], [commonColumns, handleRestoreFromArchive]);

  const renderEquipExpanded = useCallback((eq: any) => (
    <EquipExpandPanel
      eq={eq}
      access={access}
      showInvRefresh={invMode}
      showPatRefresh={patMode}
      onEdit={handleShow}
      onDelete={access.equipment_delete ? handleMoveToArchive : undefined}
      onDuplicate={handleDuplicate}
      onRefreshInventory={handleRefreshInventory}
      onRefreshPat={handleRefreshPat}
      onShowHistory={(id) => setHistoryEntityId(id)}
    />
  ), [access, invMode, patMode, handleShow, handleMoveToArchive, handleDuplicate, handleRefreshInventory, handleRefreshPat]);

  const menuActions = useMemo(() => [
    {
      label: t('TemplateForImport'),
      icon: <DownloadIcon sx={{ fontSize: 14 }} />,
      onClick: downloadSampleXLS,
    },
    {
      label: t('Import'),
      icon: <ExitToAppIcon sx={{ fontSize: 14 }} />,
      onClick: () => fileInputRef.current?.click(),
    },
    ...(access.equipment_export
      ? [{ label: `${t('Export')} XLSX`, icon: <PublishIcon sx={{ fontSize: 14 }} />, onClick: () => setShowAproveEquipment(true), divider: true }]
      : []),
  ], [access.equipment_export, downloadSampleXLS]);


  return (
    <>
      {auth ? (
        <div className="section-page">
          <TabMenu
            value={value}
            onChange={handleChangeAll}
            tabs={[
              { label: t('EqpList'), value: 'inventory' },
              { label: t('Archive'), value: 'archive' },
            ]}
            rightElement={access.equipment_settings ? (
              <Tooltip title={t('Settings')} placement="left">
                <FontAwesomeIcon
                  icon={faGear}
                  className="transition-transform duration-500 cursor-pointer opacity-60 hover:rotate-180 hover:opacity-90 mr-[8px]"
                  onClick={() => setShowEditSetting(true)}
                />
              </Tooltip>
            ) : undefined}
          >
            <TabPanel value='inventory' sx={{ padding: 0, flex: 1, minHeight: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
                <PageToolbar>
                  <SearchFilter
                    grow
                    columns={inventoryColumns}
                    search={equipSearch}
                    onSearch={setEquipSearch}
                    filters={equipFilters}
                    onFilters={setEquipFilters}
                  />

                  {access.equipment_add && (
                    <button type="button" onClick={handleShowAdd} className="btn-primary">
                      ＋ {t('AddEqp')}
                    </button>
                  )}

                  {file && (
                    <>
                      <span style={{ fontSize: 12, opacity: .7, whiteSpace: 'nowrap' }}>{file.name}</span>
                      <button type="button" onClick={() => importCSV(1, 1)} className="btn-primary">
                        <PublishIcon sx={{ fontSize: 13 }} /> {t('Import')}
                      </button>
                      <button type="button" title="Clear" onClick={() => setFile(null)} className="btn-icon">
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </>
                  )}

                  <div className="divider-v" />

                  {access.equipment_inventory_mode && (
                    <ModeBtn active={invMode} onClick={() => setInvMode(p => !p)}
                      activeStyle={{ background: 'rgba(5,150,105,.12)', color: '#059669', borderColor: 'rgba(5,150,105,.3)' }}>
                      📦 {t('Inventory')}
                    </ModeBtn>
                  )}
                  {access.equipment_pat_test && (
                    <ModeBtn active={patMode} onClick={() => setPatMode(p => !p)}
                      activeStyle={{ background: 'rgba(217,119,6,.12)', color: '#d97706', borderColor: 'rgba(217,119,6,.3)' }}>
                      ⚡ PAT
                    </ModeBtn>
                  )}
                  <ModeBtn active={bookMode} onClick={() => setBookMode(p => !p)}
                    activeStyle={{ background: 'rgba(37,99,235,.12)', color: '#2563eb', borderColor: 'rgba(37,99,235,.3)' }}>
                    📅 {t('Booking')}
                  </ModeBtn>

                  <div style={{ flex: 1 }} />
                  <div className="divider-v" />
                  <div ref={toolbarSlot} style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-l3)' }} />
                </PageToolbar>

                <div className="section-scroll">
                  {!loading ? (
                    <DataTable
                      rows={shownEquip}
                      getKey={(r) => r.id}
                      columns={inventoryColumns}
                      filterable={false}
                      onDeleteMany={access.equipment_delete ? handleDeleteMany : undefined}
                      bulkEditFields={bulkEditFields}
                      onBulkEdit={handleBulkEdit}
                      menuActions={menuActions}
                      storageKey="equipment-inventory"
                      renderExpanded={renderEquipExpanded}
                      toolbarRef={toolbarSlot}
                    />
                  ) : (
                    <LoadingCenter />
                  )}
                </div>
              </div>
            </TabPanel>

            <TabPanel value='archive' sx={{ padding: 0, flex: 1, minHeight: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
                <PageToolbar>
                  <SearchFilter grow columns={archiveColumns} search={archiveSearch} onSearch={setArchiveSearch} filters={archiveFilters} onFilters={setArchiveFilters} />
                  <div style={{ flex: 1 }} />
                </PageToolbar>
                <div className="section-scroll">
                  <DataTable
                    rows={applySearchAndFilters(archiveItems, archiveSearch, archiveFilters, archiveColumns, (e: any) => [e.item_name, e.inventory_id, e.manufacturer, e.model, e.categoryEquipment?.name, e.location?.name, e.responsibleUser?.first_name, e.responsibleUser?.last_name].filter(Boolean).join(' '))}
                    getKey={(r: any) => r.id}
                    storageKey="equipment-archive"
                    columns={archiveColumns}
                    filterable={false}
                  />
                </div>
              </div>
            </TabPanel>
          </TabMenu>

          {openShow && <ShowNewLocation
            openShow={openShow}
            setOpenShow={setOpenShow}
            locationRow={locationRow}
            categoryRow={categoryRow}
            statusRow={statusRow}
            importCSV={importCSV}
          />}
          {openDo && <ShowToDo
            openShow={openDo}
            setOpenShow={setOpenDo}
            errorRow={errorRow}
            importCSV={importCSV}
          />}
          {openNon && <ShowNon
            openShow={openNon}
            setOpenShow={setOpenNon}
            errorMessage={errorMessage}
            errorNameRow={errorNameRow}
            dublicateRow={dublicateRow}
            dublicateWhisRow={dublicateWhisRow}
            importCSV={importCSV}
          />}
          <SidePanel open={showModalAdd} onClose={() => { setShowModalAdd(false); setDuplicatePrefill(null); }}>
            <AddEquipment access={access} setShowModalAdd={setShowModalAdd} refreshEquip={refreshEquip} status={status} prefillData={duplicatePrefill ?? undefined} />
          </SidePanel>
          <SidePanel open={show} onClose={() => setShow(false)}>
            <EditEquipment setShow={setShow} status={status} access={access} refreshEquip={refreshEquip} selectedUser={selectedUser} />
          </SidePanel>
          {showAprove && (
            <ApproveDownload showAprove={showAprove} setShowAprove={setShowAprove} handXls={downloadSampleXLS} textField={'AreYouSureEquipment'} />
          )}
          {showAproveEquipment && (
            <ApproveDownload showAprove={showAproveEquipment} setShowAprove={setShowAproveEquipment} handXls={handleEquipmentXls} textField={'AreYouSureEquipmentAll'} />
          )}
          <SidePanel open={showEditSetting} onClose={() => setShowEditSetting(false)} width={624}>
            <SettingsPanelBody><EquipmentSettings /></SettingsPanelBody>
          </SidePanel>
          <SidePanel open={historyEntityId !== null} onClose={() => setHistoryEntityId(null)} width={700}>
            <div style={{ padding: 'var(--space-l2)', display: 'flex', flexDirection: 'column', gap: 'var(--space-l2)', height: '100%' }}>
              <h3 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: 'var(--text-color)' }}>📋 {t('History')}</h3>
              <ActivityLogPanel
                module="equipment"
                entityId={historyEntityId ?? undefined}
                users={users}
                maxHeight="calc(100vh - 120px)"
                fieldLabels={{
                  item_name:            'Name',
                  serial_number:        'Serial Number',
                  manufacturer:         'Manufacturer',
                  model:                'Model',
                  cost:                 'Cost',
                  notes:                'Notes',
                  inventory_id:         'Inventory ID',
                  purchase_date:        'Purchase Date',
                  warranty:             'Warranty',
                  capitalised:          'Capitalised',
                  net_book_value:       'Net Book Value',
                  depreciation_method:  'Depreciation Method',
                  funding_strand:       'Funding Strand',
                  rental_opportunity:   'Rental Opportunity',
                  pat_test:             'PAT Test',
                  pat_date:             'PAT Date',
                  pat_due:              'PAT Due (months)',
                  inventory_date:       'Inventory Date',
                  statusId:             'Status',
                  locationId:           'Location',
                  categoryEquipmentId:  'Category',
                  responsibleUserId:    'Responsible User',
                  inventoryUserId:      'Inventory User',
                  patUserId:            'PAT User',
                  departmentId:         'Department',
                }}
              />
            </div>
          </SidePanel>
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx"
            title="Import equipment file"
            style={{ display: 'none' }}
            onChange={(e: any) => setFile(e.target.files ? e.target.files[0] : null)}
          />
        </div>
      ) : (
        <LoadingCenter />
      )}
    </>
  );
};

export default Equipment;
